/* Prices in USD cents. Shopify selling plans and automatic discounts charge the order. */
(() => {
  'use strict';

  // 22/10/2026 : copie de hs-deodorant-bundle.js pour les déodorants (24,99 $ ; −3 $ dès 2, −5 $ dès 3 ;
  // Subscribe & Save −4 $, puis −1 $ dès 2 et −3 $ dès 3 ; mêmes samples offerts que le body wash).
  const CURRENT_DEODORANTS = {
    'imagine-deodorant':66965338030195,
    'rouge-640-deodorant':66965338095731,
    'aventerum-deodorant':66965338128499,
    'ocean-breeze-deodorant':66965338194035,
    'intenso-roma-deodorant':66965338259571,
    'vanilla-tabac-deodorant':66965338325107,
    'boozy-cherry-deodorant':66965338357875,
    'paradoxal-deodorant':66965338456179,
    'golden-spirit-deodorant':66962125258867,
    'ambercat-deodorant':66962125291635,
    'masculin-elixir-deodorant':66962125324403,
    'the-most-hunted-deodorant':66962125357171
  };
  function currentDeodorants(products, preview = false) {
    return (Array.isArray(products) ? products : []).filter(p => p && CURRENT_DEODORANTS[p.handle] === Number(p.id) && (preview || p.available));
  }

  function bundleReadiness(config, products, selected, samples, pickedSamples, subscription, planFor, basePrice, subPrice) {
    if (config.currency !== 'USD') return 'This offer is available in USD only.';
    if (!products.length) return 'These products are not available for purchase yet.';
    for (const index of selected) {
      if (index === null) continue;
      const item = products[index];
      if (!item?.id || !item.available) return 'This product is not available for purchase yet.';
      if (item.price !== basePrice) return 'These bundle prices are not active yet.';
      if (subscription && planFor(item)?.price !== subPrice) return 'Subscriptions for this bundle are not active yet.';
    }
    for (const index of pickedSamples) {
      if (index === null) continue;
      const sample = samples[index];
      if (!sample?.id || !sample.handle || sample.available === false) return 'The selected free sample is unavailable. Choose another scent.';
    }
    if (pickedSamples.length && !samples.some(sample => sample.id && sample.handle && sample.available !== false)) return 'Free samples for this offer are not available yet.';
    return '';
  }
  function verifyBundleCart(cart, items, bundleId, expectedUnit, currency) {
    if (cart?.currency !== currency || currency !== 'USD' || !Array.isArray(cart.items)) return false;
    const requested = new Map(items.map(item => [`${item.id}-${item.selling_plan || 0}`, item]));
    const remaining = new Map(items.map(item => [`${item.id}-${item.selling_plan || 0}`, item.quantity]));
    if (requested.size !== items.length || !Number.isSafeInteger(expectedUnit) || expectedUnit <= 0) return false;
    const lines = cart.items.filter(item => item.properties?._bundle === bundleId);
    const matches = lines.every(item => {
      const key = `${item.variant_id || item.id}-${item.selling_plan_allocation?.selling_plan?.id || 0}`;
      const source = requested.get(key);
      if (!source || !Number.isSafeInteger(item.quantity) || item.quantity < 1 || !Number.isSafeInteger(item.final_line_price)) return false;
      if (!Object.entries(source.properties || {}).every(([key,value]) => (item.properties || {})[key] === value)) return false;
      const free = source.properties?._free === '1';
      const policy = typeof window !== 'undefined' && window.HSOfferPolicy;
      const nativePrices = policy?.allowedUnitPrices(cart,item) || [];
      const validPrices = nativePrices.length ? nativePrices : [expectedUnit];
      if ((item.properties?._free === '1') !== free || !(free ? item.final_line_price === 0 : validPrices.some(value => item.final_line_price === value * item.quantity))) return false;
      const left = remaining.get(key) - item.quantity;
      remaining.set(key, left);
      return left >= 0;
    });
    return matches && [...remaining.values()].every(n => n === 0);
  }
  async function addBundleSafely({items, bundleId, currency, expectedUnit, cartUrl, addUrl, notify = () => {}}) {
    if (currency !== 'USD' || !items.length || items.some(item => !Number.isSafeInteger(Number(item.id)) || Number(item.id) <= 0 || !Number.isSafeInteger(item.quantity) || item.quantity < 1 || item.properties?._bundle !== bundleId)) throw new Error('This bundle is not available. Please review your selection.');
    let success = false, rollbackFailed = false;
    const json = async (url, options) => {
      const response = await fetch(url, options);
      let data;
      try { data = await response.json(); } catch (_) { throw new Error('The cart could not be verified. Please try again.'); }
      if (!response.ok) throw new Error(data.description || data.message || 'The bundle could not be added. Please try again.');
      return data;
    };
    const readCart = () => json(cartUrl + '.js', {headers:{Accept:'application/json'}, cache:'no-store'});
    const post = data => ({method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify(data)});
    notify({id:bundleId, phase:'start'});
    try {
      await json(addUrl + '.js', post({items}));
      const cart = await readCart();
      if (!verifyBundleCart(cart, items, bundleId, expectedUnit, currency)) throw new Error('The bundle price or gifts could not be verified. Please try again.');
      success = true;
      return cart;
    } catch (error) {
      try {
        const cart = await readCart();
        if (!Array.isArray(cart.items)) throw new Error('Invalid cart');
        const updates = Object.fromEntries(cart.items.filter(item => item.properties?._bundle === bundleId).map(item => [item.key, 0]));
        if (Object.keys(updates).length) {
          await json(cartUrl + '/update.js', post({updates}));
          const clean = await readCart();
          if (!Array.isArray(clean.items) || clean.items.some(item => item.properties?._bundle === bundleId)) throw new Error('Incomplete rollback');
        }
      } catch (_) { rollbackFailed = true; }
      if (rollbackFailed) throw new Error('This bundle could not be verified. Review your cart before checkout.');
      throw error;
    } finally { notify({id:bundleId, phase:'end', success, rollbackFailed}); }
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = {bundleReadiness, verifyBundleCart, addBundleSafely, currentDeodorants};
  if (typeof document === 'undefined') return;
  const root = document.querySelector('[data-deodorant-bundle]');
  const json = document.querySelector('[data-deodorant-bundle-data]');
  if (!root || !json || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const config = JSON.parse(json.textContent);
  const ui = window.HSBundleUI(config.ui);
  const deodorants = currentDeodorants(config.deodorants, config.preview);
  const samples = config.samples;
  deodorants.forEach(p => { p.inspiration = config.inspirations?.[p.handle.replace(/-deodorant$/, '')] || ''; });
  const current = Math.max(0, deodorants.findIndex(p => p.handle === config.current));
  const state = {mode:new URLSearchParams(window.location.search).get('purchase') === 'once' ? 'once' : 'subscription', tier:config.initial?.length >= 3 ? 3 : (config.initial?.length || 1), quantity:Math.max(3,config.initial?.length || 3), weeks:4, deodorants:config.initial?.length ? config.initial.map(h => { const i = deodorants.findIndex(p => p.handle === h); return i < 0 ? null : i; }) : [current], samples:[], busy:false};
  const $ = selector => root.querySelector(selector);
  const money = cents => new Intl.NumberFormat('en-US', {style:'currency', currency:'USD'}).format(cents / 100);
  const escape = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const isSub = () => state.mode === 'subscription';
  const count = () => state.tier === 3 ? state.quantity : state.tier;
  const unit = (n, mode = state.mode) => (mode === 'subscription' ? (n >= 3 ? 1799 : n === 2 ? 1999 : 2099) : (n >= 3 ? 1999 : n === 2 ? 2199 : 2499));
  const gifts = (n, mode = state.mode) => mode === 'subscription' ? (n >= 3 ? 3 : n === 2 ? 2 : 1) : (n >= 3 ? 1 : 0);
  const planFor = item => {
    const paid = state.deodorants.find(i => i !== null);
    const anchor = (deodorants[paid ?? current]?.plans || []).find(p => p.appId === 'appstle' && p.name === `Every ${state.weeks} weeks` && p.price === 2099);
    return (item.plans || []).find(p => p.appId === 'appstle' && p.id === anchor?.id && p.price === (item.price === 0 ? 0 : 2099));
  };
  const resize = (list, n) => { list.length = Math.min(list.length, n); while (list.length < n) list.push(null); };
  let opener, pickerKind = 'deodorant', pickerIndex = 0;
  const dialog = $('.bw-picker');
  function render() {
    const n = count(), giftCount = gifts(n), total = unit(n) * n;
    resize(state.deodorants, n); resize(state.samples, giftCount);
    root.dataset.mode = state.mode;
    root.querySelectorAll('[data-deodorant-mode]').forEach(button => {
      const active = button.dataset.deodorantMode === state.mode;
      button.classList.toggle('on', active); button.setAttribute('aria-pressed', String(active));
    });
    $('[data-deodorant-frequency]').hidden = !isSub();
    ui.updatePlans(root, {kind:'deodorant', state, n, unit, gifts, money});
    $('[data-deodorant-tiers]').innerHTML = ui.render({kind:'deodorant', tiers:[1, 2, 3], state, n, unit, gifts, money, products:deodorants, selected:state.deodorants, samples, lead:true});
    const unavailable = bundleReadiness(config, deodorants, state.deodorants, samples, state.samples, isSub(), planFor, 2499, 2099);
    const ready = !unavailable;
    const button = $('[data-deodorant-bundle-add]');
    button.disabled = !ready || state.busy;
    button.textContent = state.busy ? 'Adding…' : `${isSub() ? 'Subscribe' : 'Add to cart'} — ${money(total)}`;
    syncSticky();
    $('[data-deodorant-notice]').textContent = unavailable;
    root.querySelectorAll('button:not([data-deodorant-bundle-add]), input, select').forEach(control => {
      control.disabled = state.busy || (control.dataset.deodorantStep === '-1' && n <= 3);
    });
  }
  function syncSticky() {
    const n = count(), button = $('[data-deodorant-bundle-add]');
    const stickyPrice = document.querySelector('#hsBarP');
    const stickyButton = document.querySelector('#hsBar .atc');
    if (stickyPrice) stickyPrice.textContent = `${money(unit(n) * n)} · ${n} deodorant${n > 1 ? 's' : ''}`;
    if (stickyButton) { stickyButton.disabled = button.disabled; stickyButton.textContent = button.textContent; }
  }
  function showPicker(button) {
    opener = button; pickerKind = button.dataset.pick; pickerIndex = Number(button.dataset.slot);
    const catalogue = pickerKind === 'deodorant' ? deodorants : samples;
    const selected = pickerKind === 'deodorant' ? state.deodorants[pickerIndex] : state.samples[pickerIndex];
    $('#deodorantBundlePickerTitle').textContent = pickerKind === 'deodorant' ? `Choose deodorant ${pickerIndex + 1}` : `Choose free sample ${pickerIndex + 1}`;
    $('[data-bundle-picker-options]').innerHTML = ui.picker(catalogue, selected);
    dialog.showModal();
  }
  const setQuantity = value => { const n = Number(value); state.quantity = Number.isSafeInteger(n) ? Math.max(3,n) : 3; };
  root.addEventListener('change', event => {
    if (state.busy) return;
    if (event.target.id === 'deodorantPackQuantity') setQuantity(event.target.value);
    else if (event.target.id === 'deodorantFrequency') state.weeks = Number(event.target.value);
    else return;
    render();
  });
  root.addEventListener('click', event => {
    if (state.busy) return;
    const mode = event.target.closest('[data-deodorant-mode]');
    if (mode) { state.mode = mode.dataset.deodorantMode; render(); return; }
    const tier = event.target.closest('[data-deodorant-tier]');
    if (tier) { state.tier = Number(tier.dataset.deodorantTier); render(); $(`[data-deodorant-tier="${state.tier}"]`).focus({preventScroll:true}); return; }
    const step = event.target.closest('[data-deodorant-step]');
    if (step) { setQuantity(state.quantity + Number(step.dataset.deodorantStep)); render(); $(`[data-deodorant-step="${step.dataset.deodorantStep}"]`).focus({preventScroll:true}); return; }
    const pick = event.target.closest('[data-pick]');
    if (pick) { showPicker(pick); return; }
    const choice = event.target.closest('[data-choice]');
    if (choice) {
      (pickerKind === 'deodorant' ? state.deodorants : state.samples)[pickerIndex] = Number(choice.dataset.choice);
      dialog.close(); render(); $(`[data-pick="${pickerKind}"][data-slot="${pickerIndex}"]`).focus({preventScroll:true});
    }
    if (event.target.closest('[data-bundle-picker-close]')) dialog.close();
  });
  dialog.addEventListener('close', () => { if (opener?.isConnected) opener.focus({preventScroll:true}); });
  dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
  $('[data-deodorant-bundle-add]').addEventListener('click', async () => {
    if (state.busy || $('[data-deodorant-bundle-add]').disabled) return;
    for (const [kind, list] of [['deodorant',state.deodorants],['sample',state.samples]]) {
      const missing = list.findIndex(i => i === null);
      if (missing !== -1) { showPicker($(`[data-pick="${kind}"][data-slot="${missing}"]`)); return; }
    }
    const unavailable = bundleReadiness(config, deodorants, state.deodorants, samples, state.samples, isSub(), planFor, 2499, 2099);
    if (unavailable) { $('[data-deodorant-notice]').textContent = unavailable; return; }
    state.busy = true; render();
    // r14 : ce script tourne maintenant avant hs-offer-policy.js et le panier : l'ajout les attend (bouton « Adding… »).
    await ui.ready?.();
    const bid = `deodorant-${Date.now()}-${Math.random().toString(36).slice(2,8)}`;
    const grouped = new Map();
    const properties = {_bundle:bid, _deodorant_bundle:'1', _deodorant_quantity:String(count())};
    const add = p => {
      const plan = isSub() ? planFor(p) : null;
      const key = `${p.id}-${plan?.id || 0}`;
      if (grouped.has(key)) { grouped.get(key).quantity++; return; }
      const item = {id:Number(p.id),quantity:1,properties:{...properties}};
      if (plan) item.selling_plan = Number(plan.id);
      grouped.set(key, item);
    };
    state.deodorants.forEach(i => add(deodorants[i]));
    const chosenSamples = state.samples.map(i => samples[i]);
    // Samples are contents of the paid offer, never zero-priced standalone cart items.
    // Preferences do not authorize a quantity; fulfillment derives the quota from paid merchandise.
    if (chosenSamples.length) {
      const parent = grouped.values().next().value;
      parent.properties._hs_sample_preferences = JSON.stringify(chosenSamples.map(sample => sample.handle));
      parent.properties['Included sample scents'] = chosenSamples.map(sample => sample.name).join(', ');
    }
    const prefix = window.Shopify?.routes?.root || '/';
    try {
      await addBundleSafely({
        items:[...grouped.values()], bundleId:bid, currency:config.currency,
        expectedUnit:unit(count()), cartUrl:`${prefix}cart`, addUrl:`${prefix}cart/add`,
        notify:detail => document.dispatchEvent(new CustomEvent('hs:bundle-transaction', {detail}))
      });
      // r14 : tiroir pas encore prêt -> on l'attend (toujours « Adding… ») au lieu de partir sur /cart.
      const drawer = ui.cartReady ? await ui.cartReady() : typeof window.hsCartOpen === 'function';
      state.busy = false; render();
      if (drawer && typeof window.hsCartOpen === 'function') window.hsCartOpen();
      else window.location.assign(`${prefix}cart`);
    } catch (error) {
      state.busy = false; render(); $('[data-deodorant-notice]').textContent = error.message;
    }
  });
  // r14 : chargé plus tôt, ce script peut tourner avant que la barre collante soit dans la page : on la branche dès qu'elle existe.
  const sticky = () => {
    const stickyButton = document.querySelector('#hsBar .atc');
    if (stickyButton) { stickyButton.type = 'button'; stickyButton.removeAttribute('form'); stickyButton.addEventListener('click', () => $('[data-deodorant-bundle-add]').click()); }
    syncSticky();
  };
  if (document.readyState === 'loading' && !document.querySelector('#hsBar')) document.addEventListener('DOMContentLoaded', sticky, {once:true});
  else sticky();
  render();
})();

